import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { AppFooter } from 'containers/common/appFooter/AppFooter'
import { Button } from 'components/button/Button'
import { Spinner } from 'components/spinner/Spinner'
import { SignDigital } from 'components/signDigital/SignDigital'
import { FormContainer } from 'containers/common/formContainer/FormContainer'
import { FormTextarea } from 'components/form/textarea/FormTextarea'
import { FormCheckbox } from 'components/form/checkbox/FormCheckbox'
import { FeedbackGreeting } from 'containers/common/greeting/FeedbackGreeting'
import { ApplicantInfo } from 'containers/common/applicantInfo/ApplicantInfo'
import { EmployerInfo } from 'containers/common/employerInfo/EmployerInfo'
import { EmploymentDates } from 'containers/common/employmentDates/EmploymentDates'
import { FormByState } from 'containers/common/formByState/FormByState'
import { SignatureTextByState } from 'containers/common/signatureTextByState/SignatureTextByState'

import styles from 'containers/pages/feedback/FeedbackView.module.scss'

export const FeedbackView = ({
  isLoading,
  isSaving,
  form = {},
  formData = {},
  formMeta = {},
  handleFieldChange,
  handleSubmitForm,
  handleUploadScan,
  handleDeleteScan,
  setIsFormBusy,
  isFormBusy,
}) => (
  <Fragment>
    <div className={styles.content}>
      {isLoading && <Spinner isCentered />}

      {!isLoading && form.id && (
        <FormContainer>
          <FeedbackGreeting formData={formData} />

          {form?.referenceComment && <div className={styles.referenceComment}>{form.referenceComment}</div>}

          <ApplicantInfo formData={formData} handleFieldChange={handleFieldChange} form={form} />

          <SignatureTextByState type={form.type} />

          <SignDigital
            className={styles.signDigital}
            isSigned
            user={{
              firstName: formData.firstName.value,
              lastName: formData.lastName.value,
            }}
          />

          <div className={styles.contentSeparator} />

          <FormCheckbox
            className={styles.unknownPerson}
            title="Check this box if you can’t find or don’t know this person."
            field={formData.unknownPerson}
            onChange={value => handleFieldChange(`unknownPerson`)(!!value)}
          />

          {!formData.unknownPerson.value && (
            <Fragment>
              <FormCheckbox
                title="Check this box if applicant’s employment dates differ."
                field={formData.employmentDatesOverride}
                onChange={handleFieldChange(`employmentDatesOverride`)}
              />

              {formData.employmentDatesOverride.value && (
                <EmploymentDates formData={formData} handleFieldChange={handleFieldChange} />
              )}

              <FormByState
                formId={form.id}
                type={form.type}
                formData={formData}
                formMeta={formMeta}
                handleFieldChange={handleFieldChange}
                handleUploadScan={handleUploadScan}
                handleDeleteScan={handleDeleteScan}
                setIsFormBusy={setIsFormBusy}
              />
            </Fragment>
          )}

          <FormTextarea
            className={styles.commentBlock}
            title="Comment"
            placeholder="Your comment..."
            field={formData.comment}
            onChange={handleFieldChange(`comment`)}
          />

          <div className={styles.contentSeparator} />

          <EmployerInfo formData={formData} handleFieldChange={handleFieldChange} type={form.type} />

          <SignDigital
            className={styles.signDigital}
            signCallback={handleFieldChange('signature')}
            user={{
              firstName: formData.employerFirstName.value,
              lastName: formData.employerLastName.value,
            }}
            isSigned={formData['signature'].value}
            dateSign={formData['timestamp'].value}
          />
        </FormContainer>
      )}
    </div>

    {!isLoading && form.id && (
      <AppFooter>
        <div className={styles.footerContent}>
          <Button
            type="primary"
            size="big"
            disabled={!formMeta.isValid || isFormBusy}
            pending={isSaving}
            onClick={handleSubmitForm}>
            Submit
          </Button>
        </div>
      </AppFooter>
    )}
  </Fragment>
)

FeedbackView.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  formData: PropTypes.object,
  formMeta: PropTypes.object,
  handleFieldChange: PropTypes.func,
  handleSubmitForm: PropTypes.func.isRequired,
  handleUploadScan: PropTypes.func.isRequired,
  handleDeleteScan: PropTypes.func.isRequired,
  setIsFormBusy: PropTypes.func.isRequired,
  isFormBusy: PropTypes.bool.isRequired,
}
